import { Box, Typography } from '@mui/material';

import { Location } from '../../../../dtos.js';

type AuslastungStatisticsProps = {
  readonly auslastung: Location['seminarrundenAuslastung'][number];
};

export const AuslastungStatistics = ({ auslastung }: AuslastungStatisticsProps) => (
  <Box id="location-cell" sx={{ width: '200px', pl: 0.5 }}>
    <Typography
      variant="labelLight"
      color="primary"
      sx={{
        position: 'relative', // position & zIndex is there to show the element above the month-separating border. Can be removed if we manage to not show that one on the location-header-line.
        zIndex: 2,
        backgroundColor: 'surface.brandLightHover',
        px: '8px',
        py: '6px',
        borderRadius: '4px',
      }}
    >
      {auslastung.geblockteTage}/{auslastung.verfuegbareTage} Tagen belegt
    </Typography>
  </Box>
);
